import type { ReactNode } from "react";
import type { ContentFormat } from "../../services/educationService";
import styles from "./EdHubDetailShell.module.css";
import { ViewAsDropdown } from "./ViewAsDropdown";

type Props = {
	availableFormats?: ContentFormat[];
	onFormatSelect?: (format: ContentFormat) => void;
	onClose: () => void;
	closeLabel: string;
	children: ReactNode;
};

/**
 * Fullscreen frame for the ed-hub detail screens (article / cards / podcast).
 *
 * Fixed to the viewport at 100dvh so the inner <main> is a single, correctly
 * bounded scroll container — fixing the trimmed-card / janky-scroll bug that
 * came from `height: 100%` not resolving inside the app layout. The app
 * <Header/> is intentionally absent (true takeover).
 */
export function EdHubDetailShell({
	availableFormats,
	onFormatSelect,
	onClose,
	closeLabel,
	children,
}: Props) {
	return (
		<div className={styles.shell}>
			<header className={styles.topBar}>
				{availableFormats && onFormatSelect ? (
					<ViewAsDropdown
						availableFormats={availableFormats}
						onFormatSelect={onFormatSelect}
						openDirection="down"
					/>
				) : (
					<span />
				)}
				<button
					type="button"
					className={styles.closeBtn}
					onClick={onClose}
					aria-label={closeLabel}
				>
					×
				</button>
			</header>
			<main className={styles.main}>{children}</main>
		</div>
	);
}
